export const SDK_VERSION = '4.1.2';
export const BEACON_VERSION = '3';
export const NOTIFICATION_ORACLE_URL = 'https://beacon-notification-oracle.dev.gke.papers.tech';
//# sourceMappingURL=constants.js.map